module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('handsontable', {
    attrs: {
      "data": _vm.data,
      "settings": _vm.settings
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0cf476f1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DemoHandsOn.vue
// module id = 305
// module chunks = 2